/**
 * Represents the text configuration for the change password process.
 */
type ChangePasswordTexts = {
  /**
   * Generates the title for the change password process.
   * @param name - Optional. The user's name.
   * @returns The generated title string.
   */
  title: (name?: string) => string;
  /**
   * The subtitle for the change password process.
   */
  subtitle: string;
};

/**
 * Represents the possible status values for the change password process.
 */
export enum ChangePasswordStatus {
  /**
   * The status for the change password action.
   */
  CHANGE = 'change',
  /**
   * The status for the initial login action.
   */
  INITIAL_LOGIN = 'initial_login',
}

/**
 * Represents the configuration object for change password texts.
 */
export type ChangePasswordTextsConfig = Record<ChangePasswordStatus, ChangePasswordTexts>;
